'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultFetcher;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param  {String}
 * @param  {Array<{domain: String}|{emails: Array<String>}>}
 * @return {Promise}
 */
function defaultFetcher(url, data) {
  return _jquery2.default.ajax({
    contentType: 'application/json',
    data: JSON.stringify(data),
    dataType: 'json',
    type: 'POST',
    url: url
  });
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/avatar/defaultAvatarFetcher.js
// module id = 127
// module chunks = 0 1